import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.22 11.095a.75.75 0 0 1 1.06 0l1.72 1.72 1.72-1.72a.75.75 0 1 1 1.06 1.06l-1.72 1.72 1.72 1.72a.75.75 0 1 1-1.06 1.06L12 14.935l-1.72 1.72a.75.75 0 1 1-1.06-1.06l1.72-1.72-1.72-1.72a.75.75 0 0 1 0-1.06"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.5 4.875C1.5 3.839 2.34 3 3.375 3h17.25c1.035 0 1.875.84 1.875 1.875v1.5c0 .922-.665 1.688-1.541 1.845l-.586 9.956A3 3 0 0 1 17.378 21H6.622a3 3 0 0 1-2.995-2.824L3.04 8.22A1.876 1.876 0 0 1 1.5 6.375zM3.757 6.75h-.382A.375.375 0 0 1 3 6.375v-1.5c0-.207.168-.375.375-.375h17.25c.207 0 .375.168.375.375v1.5a.375.375 0 0 1-.375.375zm.788 1.5.58 9.838A1.5 1.5 0 0 0 6.621 19.5h10.756a1.5 1.5 0 0 0 1.498-1.412l.579-9.838z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }